<template>
	<div class="full page_container">
		<vxe-grid ref="deliverytable" :loading="loading" v-if="list_gridOptions" v-bind="list_gridOptions"
			@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
		<feeconfig-index ref="feeconfigIndex" :title="feeconfigTitle" :row="currentrow" />	
		<config-index ref="configIndex" :row="currentrow" @success="configSubmit" />	
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import feeconfigIndex from './feeconfig/index.vue'
	import configIndex from './config/index.vue'
	export default {
		mixins: [listMixins],
		props: {

		},
		data() {
			return {
				loading: false,
				activeName: '',
				activeIndex: '',
				departmentChildren: [],
				list_formConfig: [{
						field: 'distrParamName',
						title: '快递公司',
						itemRender: {
							name: '$input'
						}
					},
					{
						field: 'distrName',
						title: '快递名称',
						itemRender: {
							name: '$input'
						}
					},
					{
						field: 'offerenable',
						title: '报价启用',
						itemRender: {
							name: '$emun',
							props:{
								emptyoption:false,
								name:'enable'
							}
						}
					}
					// {
					// 	title: '操作',
					// 	fixed: "right",
					// 	align: 'center',
					// 	width: 65,
					// 	slots: {
					// 		default: ({row}) => {
					// 			return [<el-button type = "text" size = "mini" onClick = {() => {this.ddcode(row)}}>凭证</el-button>]
					// 		}
					// 	}
					// }
				],
				list_columns: [
					// {
					// 	field: 'emunid',
					// 	title: '系统枚举ID',
					// }, 
					{
						field: 'distrParamName',
						title: '快递公司',
					},
					{
						field: 'distrName',
						title: '快递名称'
					},
					{
						field: 'store',
						title: '适用店铺',
						formatter:"store"
					},
					{
						field: 'offerenable',
						title: '报价启用',
						formatter:"enable"
					},
					{
						field: 'unitUid',
						title: '快递ID'
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 130,
						slots: {
							default: ({row}) => {
								return [
									<el-button type = "text" size = "mini" onClick = {() => {this.config(row)}}>配置</el-button>,
									<el-button type = "text" size = "mini" onClick = {() => {this.feeconfig(row)}}>运费设置</el-button>
								]
							}
						}
					}					
				],
				feeconfigTitle:'运费设置',
				currentrow:{}
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.toolbarConfig = {
					size: 'mini',
					perfect: false,
					buttons: [{
						name: '导出',
						status: 'success',
						code: 'export'
					}, {
						name: '同步',
						status: 'primary',
						code: 'synchronous'
					}],
					customConfig: {
						storage: true
					},
					custom: true,
					refresh: true,
					zoom: true,
					tools: []
				}
				gridOptions.formConfig.span = 4
			},
			config(row){
				this.currentrow = row
				this.$nextTick(()=>{
					this.$refs.configIndex.modal_show()
				})
			},
			configSubmit(){
				this.$refs.deliverytable.commitProxy('query')
			},
			feeconfig(row){
				this.currentrow = row
				this.feeconfigTitle = '【'+row.distrName+'】运费设置'
				this.$nextTick(()=>{
					this.$refs.feeconfigIndex.modal_show()
				})
			},
			list(page,updateForm,other) {
				return new Promise((resolve) => {
					this.$api.parcel.list({
						...page,
						...updateForm,
						...other
					}).then((res) => {
						resolve({
							list: res
						})
					})
				})
			},
			synchronous() {
				this.loading = true
				this.$api.parcel.synchronous().then(() => {
					this.loading = false
					this.$message.success('操作成功')
					this.$refs.deliverytable.commitProxy('query')
				}, () => {
					this.loading = false
				})
			}
		},
		components: {
			configIndex,
			feeconfigIndex
		}
	}
</script>